var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:_vm.id,staticClass:"dropzone",attrs:{"action":_vm.url,"id":_vm.id}},[_c('input',{attrs:{"type":"file","name":"file"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }